/**
 * Queries every discrepancy mutation refetches. The event history expanders
 * and the header's Blocked chip (ManifestBlockState) read their own queries,
 * and resolving the last open finding clears the block server-side. The
 * line-item grids read WasteLinesUnified, which shows the Box 18a override
 * that resolving with that amount (or undoing it) sets or clears. Only
 * queries with a mounted observer are refetched, so this costs nothing when
 * no grid is on screen.
 */
export const DISCREPANCY_MUTATION_REFETCH_QUERIES = [
  "ProcessedManifests",
  "ComplianceManifestData",
  "DiscrepancyEvents",
  "ManifestBlockState",
  "BulkManifestDiscrepancies",
  "WasteLinesUnified",
];
